/**
 * 延迟加载类
 */
const supportsIntersectionObserver = "IntersectionObserver" in window;

/**
 * 判断浏览器支持不支持lazy loading
 */
export const supportsLazyLoading = () => {
  return 'loading' in HTMLImageElement.prototype;
}

/**
 * lazy loading
 * @param cssSelector 
 * @param callback 
 * @param options 
 */
export const lazyLoad = (cssSelector: string | Element[], callback: (el: HTMLElement) => void, options?: any) => {
  if (supportsLazyLoading()) {
  }

  const config = Object.assign({}, {
    unsupportedTimeout: 2000,
    autoLoadTimeout: 0,
    observerConfig: {
      rootMargin: "0px 0px 50px 0px",
      threshold: 0
    }
  }, options || {});

  const elements = typeof cssSelector == 'string' ? document.querySelectorAll(cssSelector) : cssSelector;

  if (supportsIntersectionObserver) {

    const intersectionObserver = new IntersectionObserver((function (entries, observe) {
      entries.forEach((function (e) {
        // 如果进入可视区域，需要执行回调函数
        if (e.isIntersecting) {
          callback(e.target as HTMLElement);
          // 回调函数执行后，就删掉，避免再次执行
          observe.unobserve(e.target);
        }
      }
      ))
    }
    ), config.observerConfig);

    //注册监听
    elements.forEach((function (e) {
      intersectionObserver.observe(e)
    }
    ));

    // 如果配置自动加载时间，不管用户有没有进入可视区域，都会在指定的时间后加载。
    if (config.autoLoadTimeout) {
      elements.forEach((function (e) {
        setTimeout((function () {
          callback(e as HTMLElement);
          intersectionObserver.unobserve(e);
        }
        ), config.autoLoadTimeout)
      }
      ));
    }
  } else {
    for (let i = 0; i < elements.length; i++) {
      setTimeout(callback.bind(elements[i], elements[i] as HTMLElement), config.unsupportedTimeout)
    }
  }
}